module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "purchase"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/collections/bespoke-service"
    }
  }, [_c('div', {
    staticClass: "bannerspacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("\n          Dovedale Design"), _c('Br'), _vm._v("\n          Studio’S"), _c('Br'), _vm._v("\n          Bespoke Service\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('LogoMarque')], 1)])])]), _vm._v(" "), _vm._l((_vm.slugs), function(slug) {
    return [_c('collection-items', {
      attrs: {
        "slug": slug,
        "collections": _vm.collections,
        "options": {
          customOrders: false,
          isPurchase: true
        }
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9f0c66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Purchase.vue
// module id = 390
// module chunks = 1